module.exports = require("./interopRequireDefault.js");


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/helpers/interop-require-default.js
// module id = 1095
// module chunks = 0